import { Box, Flex, Spinner } from "@chakra-ui/react";
import {
  AttachmentFileBox,
  AttachmentFileText,
  AttachmentFileSpinner,
  AttachmentCloseBtn,
} from "../style";
import { getFileIcon, getFileType } from "@root/utils/fileType";
import { FILE_STATUS } from "@root/constants";

interface AttachmentFileCardProps {
  file: any;
  onRemove: (identifier: string) => void;
  showCloseButton?: boolean;
  isLoading?: boolean;
}

/**
 * Reusable component for displaying a single attachment file card
 */
export const AttachmentFileCard = ({
  file,
  onRemove,
  showCloseButton = true,
  isLoading = false,
}: AttachmentFileCardProps) => {
  const isProcessing = file?.status === FILE_STATUS.PROCESSING || isLoading;
  const fileName =
    file?.fileName_key ||
    file?.name?.split("/").pop() ||
    file?.fileName?.split("/").pop() ||
    file?.name ||
    file?.fileName;

  const fileIcon = file?.fileName ? getFileIcon(file.fileName) : getFileIcon(file.name);
  const fileType = file?.fileName ? getFileType(file.fileName) : getFileType(file.name);

  return (
    <AttachmentFileBox>
      <Flex justify="space-between" align="center">
        <AttachmentFileText>{fileName}</AttachmentFileText>
        {showCloseButton && !isProcessing && (
          <AttachmentCloseBtn onClick={() => onRemove(file?.id || file?.docId)}>
            ×
          </AttachmentCloseBtn>
        )}
      </Flex>

      <Flex align="center" gap="4px" width="100%">
        <Box
          w="20px"
          h="20px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {isProcessing ? (
            <Spinner size="sm" color="blue.500" speed="0.65s" />
          ) : (
            fileIcon
          )}
        </Box>
        <Box>{fileType}</Box>
      </Flex>
    </AttachmentFileBox>
  );
};
